import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import Icon from 'assets/components/icon/Icon';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import { defaultInputDateTimeFormat } from 'assets/utils/data/Date';
import { flatten, isEmpty, uniqBy } from 'lodash';
import { useContractConsentProvider } from '../ContractConsent.Hooks';

export default function ContractConsentFilters() {
  const { lang } = getLocales();
  const { listApi, dealersApi, acceptanceStatusItems, buildAcceptanceStatusFilter, typeItems } =
    useContractConsentProvider();
  const { isDealer } = useAuthStore();

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      search={listApi.body?.search}
      onSearch={(search) => listApi.execute((body) => ({ ...body, search, offset: 0 }))}
      onSortById={(sort) => listApi.execute((body) => ({ ...body, ...sort }))}
      filters={listApi.body ?? {}}
      onFilter={(newFilters) =>
        listApi.execute((prev) => ({
          ...prev,
          ...newFilters,
          offset: 0,
        }))
      }
      onReset={() => {
        listApi.reset();
      }}
      onOpen={() => {
        if (!dealersApi.payload) dealersApi.execute((body) => body);
      }}
      render={({ tempFilters, setFilters }) => {
        const dealers = dealersApi?.payload?.data ?? [];

        const products = !isEmpty(tempFilters?.dealerId)
          ? flatten(
              dealers.filter((d) => tempFilters?.dealerId?.some((id: number) => id === d.id)).map((d) => d.products)
            )
          : uniqBy(flatten(dealers.map((d) => d.products)), (p) => p.id);
        return (
          <>
            <DateInput
              isLocal
              name="createdAtFromDateUtc"
              label={lang.createdAtFromDate}
              dateTimeFormat={defaultInputDateTimeFormat}
              value={tempFilters?.createdAtFromDateUtc}
              onChange={setFilters}
              icon={<Icon class="fas-calendar-alt" />}
            />
            <DateInput
              isLocal
              name="createdAtToDateUtc"
              label={lang.createdAtToDate}
              dateTimeFormat={defaultInputDateTimeFormat}
              value={tempFilters?.createdAtToDateUtc}
              onChange={setFilters}
              icon={<Icon class="fas-calendar-alt" />}
            />
            <DateInput
              isLocal
              name="modifiedAtFromDateUtc"
              label={lang.modifiedAtFromDate}
              dateTimeFormat={defaultInputDateTimeFormat}
              value={tempFilters?.modifiedAtFromDateUtc}
              onChange={setFilters}
              icon={<Icon class="fas-calendar-alt" />}
            />
            <DateInput
              isLocal
              name="modifiedAtToDateUtc"
              label={lang.modifiedAtToDate}
              dateTimeFormat={defaultInputDateTimeFormat}
              value={tempFilters?.modifiedAtToDateUtc}
              onChange={setFilters}
              icon={<Icon class="fas-calendar-alt" />}
            />
            <DateInput
              isLocal
              name="expiresAtFromDateUtc"
              label={lang.expiresAtFromDate}
              dateTimeFormat={defaultInputDateTimeFormat}
              value={tempFilters?.expiresAtFromDateUtc}
              onChange={setFilters}
              icon={<Icon class="fas-calendar-alt" />}
            />
            <DateInput
              isLocal
              name="expiresAtToDateUtc"
              label={lang.expiresAtToDate}
              dateTimeFormat={defaultInputDateTimeFormat}
              value={tempFilters?.expiresAtToDateUtc}
              onChange={setFilters}
              icon={<Icon class="fas-calendar-alt" />}
            />
            <SelectInput
              name="type"
              label={lang.type}
              data={typeItems}
              value={tempFilters?.type}
              onChange={setFilters}
              icon={<Icon class="fas-check" />}
            />
            <SelectInput
              name="acceptanceStatusId"
              label={lang.acceptanceStatus}
              data={acceptanceStatusItems}
              value={tempFilters?.acceptanceStatusId}
              onChange={({ acceptanceStatusId }) => {
                const filter = buildAcceptanceStatusFilter(acceptanceStatusId) || {};

                setFilters({
                  acceptanceStatusId: acceptanceStatusId,
                  acceptanceState: filter.acceptanceState,
                  isManuallyAccepted: filter.isManuallyAccepted,
                });
              }}
              icon={<Icon class="fas-check" />}
            />
            <SelectInput
              name="productId"
              label={lang.products}
              data={products.map((item) => ({
                ...item.displayInfo,
                icon: <Icon class="fas-box" />,
              }))}
              isMultiselect
              value={tempFilters?.productId}
              onChange={setFilters}
              icon={<Icon class="fas-box" />}
            />
            {dealers.length > 1 && (
              <SelectInput
                name="dealerId"
                label={lang.dealers}
                data={dealers.map((item) => ({
                  ...item.displayInfo,
                  icon: <Icon class="fas-cloud" />,
                }))}
                isMultiselect
                value={tempFilters?.dealerId}
                onChange={setFilters}
                disabled={isDealer}
                icon={<Icon class="fas-cloud" />}
              />
            )}
          </>
        );
      }}
    />
  );
}
